module.exports = __webpack_public_path__ + "img/show_cn_text_2.ea44dd1e.png";